<template>
    <app-tooltip v-if="!isLive()" :value="tooltipValue">
        <edit-boolean
            v-model="inputValue"
            :disabled="disabled"
            label="Mock API"
            type="switch"
            :hide-details="true"
            color="primaryText"
            class="app-toggle"
            label-class="primaryText--text font-weight-bold"
        />
    </app-tooltip>
</template>

<script>
import isLive from '@/lib/helpers/isLive';

export default {
    name: 'AppToggleMockApi',
    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        isLive
    }),
    computed: {
        inputValue: {
            get() {
                return this.$store.getters['app/mock_api'];
            },
            set() {
                this.$store.dispatch('app/toggleMockApi');
            }
        },
        tooltipValue() {
            return this.inputValue ? 'Switch off to show real data' : 'Switch on to show mock data';
        }
    }
};
</script>
